  if (!customElements.get('myrevora-video-carousel')) {
    customElements.define('myrevora-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.track = this.querySelector('[data-video-track]');
        if (!this.track) return;
        this.cards = [...this.querySelectorAll('[data-video-card]')];
        this.navigation = this.querySelector('[data-video-navigation]');
        this.previous = this.querySelector('[data-video-previous]');
        this.next = this.querySelector('[data-video-next]');
        this.events = new AbortController();
        const signal = this.events.signal;
        this.previous?.addEventListener('click', () => this.move(-1), { signal });
        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.videoStates = new Map();
        this.querySelectorAll('[data-video-player]').forEach((player) => {
          if (player.matches('myrevora-viewport-video')) return;
          const video = player.querySelector('video');
          const button = player.querySelector('[data-video-toggle]');
          const sync = () => {
            const playing = !video.paused && !video.ended;
            player.toggleAttribute('data-playing', playing);
            player.toggleAttribute('data-started', video.currentTime > 0 || playing);
            const action = playing ? 'השהה סרטון' : video.currentTime > 0 && !video.ended ? 'המשך סרטון' : 'הפעל סרטון';
            button.setAttribute('aria-label', `${action}: ${button.dataset.videoLabel}`);
          };
          this.videoStates.set(video, sync);
          let gesture;
          button.addEventListener('pointerdown', (event) => {
            gesture = { x: event.clientX, y: event.clientY, scroll: this.track.scrollLeft, moved: false };
          }, { passive: true, signal });
          button.addEventListener('pointermove', (event) => {
            if (gesture && Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) gesture.moved = true;
          }, { passive: true, signal });
          button.addEventListener('pointercancel', () => {
            if (gesture) gesture.moved = true;
          }, { passive: true, signal });
          button.addEventListener('click', (event) => {
            const swiped = event.detail !== 0 && gesture && (gesture.moved || Math.abs(this.track.scrollLeft - gesture.scroll) > 8);
            gesture = null;
            if (swiped) return;
            if (!video.paused && !video.ended) {
              video.pause();
              sync();
              return;
            }
            this.querySelectorAll('video').forEach((other) => {
              if (other !== video) {
                other.pause();
                this.videoStates.get(other)?.();
              }
            });
            if (video.ended) video.currentTime = 0;
            player.setAttribute('data-playing', '');
            const playback = video.play();
            sync();
            playback.catch(sync);
          }, { signal });
          video.addEventListener('play', () => {
            document.querySelectorAll('myrevora-video-carousel video, myrevora-how-it-works video').forEach((other) => {
              if (other !== video) other.pause();
            });
            sync();
          }, { signal });
          ['pause', 'ended', 'error', 'emptied'].forEach(type => video.addEventListener(type, sync, { signal }));
          sync();
        });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-video-card]');
          if (card && this.contains(card)) this.reveal(card);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      update() {
        this.toggleAttribute('data-rtl', getComputedStyle(this.track).direction === 'rtl');
        const viewport = this.track.getBoundingClientRect();
        const fullyVisible = (card) => {
          const rect = card.getBoundingClientRect();
          return rect.left >= viewport.left - 2 && rect.right <= viewport.right + 2;
        };
        if (this.navigation) this.navigation.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        if (this.previous) this.previous.disabled = !this.cards.length || fullyVisible(this.cards[0]);
        if (this.next) this.next.disabled = !this.cards.length || fullyVisible(this.cards[this.cards.length - 1]);
      }

      move(step) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        const start = this.track.getBoundingClientRect()[edge];
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect()[edge] - start);
          if (delta < distance) {
            closest = index;
            distance = delta;
          }
        });
        const index = Math.max(0, Math.min(this.cards.length - 1, closest + step));
        this.reveal(this.cards[index]);
      }

      reveal(card) {
        card.scrollIntoView({
          inline: 'start',
          block: 'nearest',
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    });
  }
